export const Mode = {
  BEZELED: 'bezeled',
  PLAIN: 'plain',
  GRAY: 'gray',
} as const;

export type Mode = Union<typeof Mode>;

export const Size = {
  SMALL: 's',
  MEDIUM: 'm',
  LARGE: 'l',
} as const;

export type Size = Union<typeof Size>;
